import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MaintenancePage() {
  const { t } = useTranslation();
  return (
    <div style={styles.container}>
      <h1 style={styles.code}>🛠</h1>
      <h2 style={styles.text}>{t('maintenance.title', 'Site under maintenance')}</h2>
      <p style={styles.desc}>
        {t('maintenance.desc', 'We are performing scheduled maintenance. Please check back soon.')}
      </p>
      <Link to="/login" style={styles.link}>{t('maintenance.login', 'Admin login')}</Link>
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    margin: "10vh",
    fontFamily: "Arial, sans-serif",
  },
  code: {
    fontSize: "6rem",
  },
  text: {
    fontSize: "2rem",
    margin: "1rem 0",
  },
  desc: {
    fontSize: "1rem",
    color: "#666",
  },
  link: {
    marginTop: "2rem",
    display: "inline-block",
    padding: "0.8rem 1.2rem",
    backgroundColor: "#41aa57ff",
    color: "white",
    borderRadius: "8px",
    textDecoration: "none",
  },
};
